import {useEffect, useRef} from 'react';
import {useInView} from 'react-intersection-observer';
import type {z} from 'zod';
import type {
  CompanySchema,
  CustomTagSchema,
} from '../../../../core/entities/company/schema';
import {CustomTagCompaniesFramePresentation} from './presentation';

// CustomTagCompaniesFrameContainersはcontainers.tsxに移動しました
// このファイルにはCustomTagCompaniesFrameContainer（単一管理）のみを残します

// 1つ分のContainer（refや副作用管理）
type SingleContainerProps = {
  componentID: string;
  customTag: z.infer<typeof CustomTagSchema>;
  companies: z.infer<typeof CompanySchema>[];
  isLoading: boolean;
  withOdd: boolean;
  addPaddingLeft: boolean;
  page: string;
  handleSetTotalCount?: (key: string, count: number) => void;
  hasLeftPadding?: boolean;
};

export const CustomTagCompaniesFrameContainer: React.FC<
  SingleContainerProps
> = ({
  componentID,
  customTag,
  companies,
  isLoading,
  withOdd,
  handleSetTotalCount,
  addPaddingLeft,
  page,
}) => {
  const {ref} = useInView({triggerOnce: true});
  const prevCompaniesLength = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (handleSetTotalCount) {
      const currentLength = companies.length;
      if (prevCompaniesLength.current !== currentLength) {
        handleSetTotalCount(String(customTag.id), currentLength);
        prevCompaniesLength.current = currentLength;
      }
    }
  }, [companies, handleSetTotalCount, customTag.id]);

  return (
    <CustomTagCompaniesFramePresentation
      componentID={componentID}
      ref={ref}
      isLoading={isLoading}
      customTag={customTag}
      companies={companies}
      withOdd={withOdd}
      addPaddingLeft={addPaddingLeft}
      page={page}
    />
  );
};
